export default __webpack_public_path__ + "static/media/refresh.0ec40fb7.png";